export const UserKey = 'USER_INFO'
export const TokenKey = 'USER_TOKEN'
export const CustomerServiceKey = 'CUSTOMER_SERVICE'
export const LayoutCollpaseKey = 'LAYOUT_COLLAPSE'
export const LicenceKey = 'LICENCE_KEY'
export const TermsKey = 'TERMS_KEY'


// WEBPACK FOOTER //
// ./src/utils/cookies/keys.js